import { createFileRoute } from "@tanstack/react-router";
import { GroupPreregistration } from "@/components/pre-registration/GroupPreregistration";
import { useTranslation } from "react-i18next";
import { useCompanyAdminAccess } from "@/hooks/useCompanyAdminAccess";
import { useWelcomeVisitAccess } from "@/hooks/useWelcomeVisitAccess";

export const Route = createFileRoute(
  "/_portal/company/$companyId/visitors/preregistrations/new",
)({
  component: Preregistration,
});

function Preregistration() {
  const { t } = useTranslation();
  const { companyId } = Route.useParams();

  useWelcomeVisitAccess();

  const { allowCompanyAdminAccess } = useCompanyAdminAccess(companyId);

  const breadcrumbs = [
    {
      label: t("SIDEBAR.COMPANY_VISITORS"),
      path: `/company/${companyId}/visitors`,
    },
    {
      label: t("BUILDING_VISITORS.PRE_REG"),
      path: `/company/${companyId}/visitors/preregistrations`,
    },
    {
      label: t("PREREGISTRATION.HEADER"),
      path: `/company/${companyId}/visitors/preregistrations/new`,
    },
  ];

  if (!allowCompanyAdminAccess) {
    return null;
  }

  return (
    <GroupPreregistration
      noResultsText={t("PREREGISTRATION.NO_RESULTS_COMPANY")}
      showAddHost
      breadcrumbs={breadcrumbs}
      companyId={companyId}
    />
  );
}
